// extracted by mini-css-extract-plugin
export default {"modalContainer":"_1JAlx","modalHeader":"_3Ex1x","modalContent":"_3TPdD","closeButton":"_3P6uR","modalBody":"_2epkF","modalFooter":"_2xbjf"};